import React, { useState, useEffect, useContext, useRef } from "react";
import { MyContext } from "../../MyContextApi";
import "./../../styles/App.css";
import SectionTable from "./Dashboard/Table";
import getCountofPlatform from "../../API/getCountOfPlatform";
import getCountOfSection from "../../API/getCountOfSection";
import getTrendingHashtags from "../../API/hashtags";
import getKeyWords from "../../API/keywords";
import sessionDetails from "../../API/sessionDetails";
import "font-awesome/css/font-awesome.min.css";
import CardCarousel from "./Dashboard/CardCarousel";
import dayjs from "dayjs";
import DonutChart from "./Dashboard/Dashboard Charts/DonutChart";
import CylinderChart from "./Dashboard/Dashboard Charts/CylinderChart";
import LineChart from "./Dashboard/Dashboard Charts/LineChart";
import Stacked3DColumnChart from "./Dashboard/Dashboard Charts/StackedBar";
import AddUser from "../AddUser";
import PackedBubbleChart from "./Dashboard/Dashboard Charts/PackedBubbleChart";
import getLanguageCount from "../../API/LanguageCount";
import AvatarDropdown from "./Dashboard/DropDown";
import AOS from "aos"; // Import AOS library
import "aos/dist/aos.css"; // Import AOS CSS
import { generateHash } from "../../API/hashUtil";
import ReactProSidebar from "./Dashboard/ReactProSidebar";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import { Fade, Backdrop } from "@mui/material";
import { Modal, Box } from "@mui/material";
import "../../styles/DashboardDateRangeAccordion.css";
import getDefaulters from "../../API/Defaulter";
import WordCloudCarousel from "./Dashboard/Dashboard Charts/WordCloudCarousel";
import DateRangePickerModal from "./Dashboard/ModalDate";
import NavBar from "./Dashboard/NavBar";
import MultipleSelectChip from "./Dashboard/TopicMenu";
import TopicMenu from "./Dashboard/TopicMenu";
import DateRangeIcon from "@mui/icons-material/DateRange";
import BackdropLoader from "./Dashboard/BackdropLoader";
import ChartSkeletonLoader from "./Dashboard/Dashboard Charts/ChartSkeleton";
import PlatformPostsBarChart from "./Dashboard/Dashboard Charts/PlatformPosts";
import getBarchartData from "../../API/barchartData";
import WordCloudChart from "./Dashboard/Dashboard Charts/WordCloud";
import WordCloudHash from "./Dashboard/Dashboard Charts/WordCloudHash";
import WordCloudDefaulter from "./Dashboard/Dashboard Charts/WordCloudDefaulter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import KeywordChips from "./Dashboard/Dashboard Charts/KeywordChips";
import DataCountsCards from "./Dashboard/Dashboard Charts/DataCountsCards";
import getAllKeyWords from "../../API/alltimekeywords";
import { useAuth } from "../../context/AuthContext";
function DashBoard() {
  const [loading, setLoading] = useState(true);
  const [sessionData, setSeessionData] = useState([]);
  const [crawlingKeywords, setCrawlingKeywords] = useState(null);
  const [hashtagTrend, setHashtagTrend] = useState([]);
  const [bardata, setBarData] = useState([]);
  const [barchartData, setBarchartData] = useState([]);
  const [sectiondata, setSectionData] = useState(null);
  const [allhashTrend, setAllhashTrend] = useState([]);
  const [languagecount, setLanguageCount] = useState([]);
  const [defaulters, setDefaulters] = useState(null);
  const [alltimekeywords, setAlltimekeywords] = useState(null);
  const [activeBtn, setActiveBtn] = useState("7d");
  const [isSelectingDate, setIsSelectingDate] = useState(false); // Flag for date selection

  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {
    toggleButton,

    toggleAdduser,
    selectedRange,

    setFromDateTimeFormatted,
    setToDateTimeFormatted,
    dashboardDate,
  } = useContext(MyContext);
  const { role: userRole } = useAuth();

  let dashEnd;
  let dashStart;

  if (dashboardDate && dashboardDate.length > 0) {
    dashStart = dashboardDate[0] && dashboardDate[0].startDate;
    dashEnd = dashboardDate[0] && dashboardDate[0].endDate;
  }
  const handleApply = () => {
    setDateStart(dashStart);
    setDateEnd(dashEnd);
    setOpen(false);
  };

  const [showDateRange, setShowDateRange] = useState(false);
  let [toSimple, setToSimple] = useState("");

  const handleFromDateTimeChange = (fromDateTime) => {
    const formattedFromDateTime = dayjs(fromDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]",
    );
    setFromDateTimeFormatted(formattedFromDateTime);
    const simpleFromDateTime = dayjs(fromDateTime).format("DD-MM-YYYY");
    // setFromSimple(simpleFromDateTime);
    setShowDateRange(true);
  };

  const handleToDateTimeChange = (toDateTime) => {
    const formattedToDateTime = dayjs(toDateTime).format(
      "YYYY-MM-DDTHH:mm:ss[Z]",
    );
    setToDateTimeFormatted(formattedToDateTime);
    const simpleToDateTime = dayjs(toDateTime).format("DD-MM-YYYY");
    setToSimple(simpleToDateTime);
    setShowDateRange(true);
  };
  //
  const token = localStorage.getItem("Token");
  const apiFetch = async () => {
    setOpenBackdrop(true); // Show backdrop while promises are executing

    let startDateStr = dateStart ? dateStart : null;
    let endDateStr = dateEnd ? dateEnd : null;
    //

    let stringParams = {
      startDateStr: dateStart ? dateStart.toString() : "",
      endDateStr: dateEnd ? dateEnd.toString() : "",
    };
    let stringParams2 = {
      startDateStr: dateStart ? dateStart.toString() : "",
      endDateStr: dateEnd ? dateEnd.toString() : "",
    };
    const hexHash = generateHash(stringParams);
    const hexHash2 = generateHash(stringParams2);

    try {
      await Promise.allSettled([
        // getCountOfSentiment(token, startDateStr, endDateStr),
        getCountofPlatform(
          token,
          startDateStr,
          endDateStr,

          hexHash,
        ), //0
        getCountOfSection(token, startDateStr, endDateStr, hexHash), //1
        getTrendingHashtags(token, startDateStr, endDateStr, hexHash), //2
        getKeyWords(token, startDateStr, endDateStr, hexHash), //3
        sessionDetails(token), //4
        // sessionDetails(token, startDateStr, endDateStr, hexHash2), //4

        getLanguageCount(token, startDateStr, endDateStr, hexHash), //5
        getDefaulters(token, startDateStr, endDateStr, hexHash2), //6
        getBarchartData(token, startDateStr, endDateStr, hexHash2), //7
        getAllKeyWords(token, startDateStr, endDateStr, hexHash), //8
      ])
        .then((values) => {
          // setTestValue(values[0].status === "fulfilled" ? values[0].value : null);
          setBarData(values[0].status === "fulfilled" ? values[0].value : null);
          //
          const sectionDataRaw =
            values[1].status === "fulfilled" ? values[1].value : null;
          if (sectionDataRaw) {
            const sortedSectionData = Object.fromEntries(
              Object.entries(sectionDataRaw.data).sort((a, b) => {
                const numA = parseInt(a[0].replace(/^31b/, ""));
                const numB = parseInt(b[0].replace(/^31b/, ""));
                return numA - numB;
              }),
            );
            setSectionData({ data: sortedSectionData });
          } else {
            setSectionData(null);
          }

          setHashtagTrend(
            values[2].status === "fulfilled" ? values[2].value : null,
          );
          setAllhashTrend(
            values[2].status === "fulfilled" ? values[2].value.data : [],
          );
          setCrawlingKeywords(
            values[3].status === "fulfilled" ? values[3].value.data : [],
          );
          setSeessionData(
            values[4].status === "fulfilled" ? values[4].value.data : [],
          );
          setLanguageCount(
            values[5].status === "fulfilled" ? values[5].value.data : [],
          );
          setDefaulters(
            values[6].status === "fulfilled" ? values[6].value.data : [],
          );
          setBarchartData(
            values[7].status === "fulfilled" ? values[7].value.data : [],
          );
          setAlltimekeywords(
            values[8].status === "fulfilled" ? values[8].value.data : [],
          );
          const allFulfilled = values
            .slice(0, 6)
            .every((result) => result.status === "fulfilled");

          if (allFulfilled) {
            setLoading(false);
            setOpenBackdrop(false);
          }
          //
          //
        })
        .catch((err) => {
          console.error(err, "Something went wrong");
        });
    } catch (error) {
      console.error("Error during fetching:", error);
      setOpenBackdrop(false); // Ensure backdrop hides on error
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000, // Set the animation duration (in milliseconds)
      easing: "ease-in-out", // Define the animation easing type
    });

    // sendDataToServer();
    apiFetch();
    //
    const today = new Date();
    const from = new Date();
    from.setDate(today.getDate() - 7);
    setShowDateRange(true);
  }, [dateEnd, dateStart]);

  // }, [toDateTimeFormatted, fromDateTimeFormatted]);
  function formatDisplayDate(isoDate) {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    return `${day} ${month}`;
  }

  return (
    <div className="container">
      <BackdropLoader open={openBackdrop} />
      {/* <div className="navbar"> */}
      <NavBar />
      {/* </div> */}

      {/* Main content */}

      {toggleAdduser ? (
        <AddUser />
      ) : (
        <main className={`${toggleButton ? "mainshow" : "mainhide"}`}>
          {/* MAIN TITLE */}

          <div className="main__title">
            {/* HASHTAG MARQUEE */}
            <div
              style={{
                justifyContent: "flex-start",
                gap: "10px",
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <Tooltip
                title="Select Date Range"
                placement="right"
                TransitionComponent={Fade}
              >
                <Button
                  variant="outlined"
                  onClick={handleOpen}
                  sx={{
                    height: "40px",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    fontFamily: "'Host Grotesk', sans-serif",
                    textTransform: "none",
                    display: "flex",
                    alignItems: "center", // Ensure alignment of icon and text
                    gap: "8px", // Add spacing between icon and text
                  }}
                >
                  <DateRangeIcon sx={{ fontSize: 20 }} />
                  {/* MUI Date Range Icon */}
                  {dateStart && dateEnd
                    ? `${formatDisplayDate(dateStart)} - ${formatDisplayDate(
                        dateEnd,
                      )}`
                    : "Range"}
                </Button>
              </Tooltip>

              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    minWidth: 400,
                    "& .rdrMonths": {
                      minHeight: "330px",
                      alignItems: "flex-start",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <h2
                      id="modal-title"
                      style={{
                        fontFamily: "'Host Grotesk', sans-serif",
                        color: "#2c4e80",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      Select a Date Range
                    </h2>
                    <Button
                      onClick={handleClose}
                      style={{
                        color: "black",
                        padding: 0,
                        width: "40px",
                        height: "40px",
                        minWidth: 0,
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} size="lg" />
                    </Button>
                  </div>
                  <DateRangePickerModal />
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="outlined"
                      sx={{
                        mt: 2,
                        backgroundColor: "white",
                        fontFamily: "'Host Grotesk', sans-serif",
                      }}
                      onClick={handleApply}
                    >
                      Apply
                    </Button>
                  </div>
                </Box>
              </Modal>
              {/* <TopicMenu /> */}
            </div>
            <div
              className="scrolling-bar"
              style={{
                height: "40px",
                color: "#FFFFFF", // Neutral text color for contrast
                fontFamily: "DM Sans, sans-serif",
                fontWeight: "700",
                lineHeight: "40px", // Matches the height for vertical centering
                letterSpacing: "0.5px",
                background: "linear-gradient(90deg, #6A11CB 0%, #2575FC 100%)", // Gradient with soft purple and blue tones
                borderRadius: "20px",
                margin: "15px auto", // Center the marquee horizontally
                padding: "0 20px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", // Softer shadow for depth
                display: "flex",
                alignItems: "center", // Ensures proper alignment
                overflow: "hidden",
                maxWidth: dateStart && dateEnd ? "80%" : "86%", // Restricts width for better responsiveness
                marginRight: "55px",
              }}
            >
              {Object.keys(allhashTrend).length > 0 ? (
                <marquee
                  scrollamount="5"
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "16px", // Balanced text size
                  }}
                >
                  {Object.entries(allhashTrend).map(
                    ([hashtag, count], index) => {
                      const formattedHashtag = hashtag.startsWith("#")
                        ? hashtag
                        : `#${hashtag}`;
                      return (
                        <span
                          key={index}
                          style={{
                            marginLeft: "2rem",
                            fontWeight: "600",
                            fontSize: "17px",
                            fontStyle: "italic",
                            color: "#F0F8FF", // Alice Blue for soft highlight
                          }}
                        >
                          {formattedHashtag}
                        </span>
                      );
                    },
                  )}
                </marquee>
              ) : (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    lineHeight: "40px",
                    fontSize: "17px",
                    color: "#F0F8FF", // Matches hashtag color
                  }}
                >
                  <strong>Hashtags Not Available</strong>
                </div>
              )}
            </div>
          </div>

          <div className="main__container">
            <>
              {<CardCarousel />}
              {/* CHARTS */}

              {openBackdrop ? (
                <ChartSkeletonLoader />
              ) : (
                <>
                  <KeywordChips data={alltimekeywords} />
                  <DataCountsCards />
                  <div className="charts">
                    <div className="charts__left">
                      {/* <h1>Social Media Stats</h1> */}
                      <div
                        className="charts__left_child"
                        style={{ overflow: "hidden" }}
                        // data-aos="fade-up"
                        // data-aos-duration="1500"
                      >
                        {/* <WordCloudCarousel
                        wordData={crawlingKeywords}
                        wordHash={hashtagTrend}
                        wordDefault={defaulters}
                      /> */}
                        <WordCloudChart
                          wordcloudData={
                            crawlingKeywords ? crawlingKeywords : []
                          }
                        />
                      </div>
                      <div
                        className="charts__left_child"
                        style={{ overflow: "hidden" }}
                        // data-aos="fade-up"
                        // data-aos-duration="1500"
                      >
                        <WordCloudHash
                          wordcloudData={hashtagTrend ? hashtagTrend?.data : []}
                        />
                      </div>
                      <div
                        className="charts__left_child"
                        style={{ overflow: "hidden" }}
                      >
                        <WordCloudDefaulter
                          wordcloudData={defaulters ? defaulters : []}
                        />
                      </div>
                      <div
                        className="charts__left_child_bubble"
                        // data-aos="fade-up"
                        // data-aos-duration="1500"
                      >
                        <PackedBubbleChart langdata={languagecount} />
                      </div>
                      {/* <div
                        className="charts__left_child"
                        // data-aos="fade-up"
                        // data-aos-duration="1500"
                      >
                        <Stacked3DColumnChart
                          barchartData={bardata ? bardata?.data : []}
                        />
                      </div>
                      <div className="charts__left_child">
                        <DonutChart donutData={bardata ? bardata?.data : []} />
                      </div> */}
                      {userRole !== "ROLE_USER" && (
                        <div
                          className="charts__left_child_big"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          <LineChart data={sessionData} />
                          {/* <PlatformPostsBarChart data={sessionData} /> */}
                        </div>
                      )}
                      <div className="charts__left__title"></div>
                    </div>
                    <div className="charts__right">
                      <div className="charts__right__table">
                        {sectiondata && (
                          <SectionTable
                            tableData={sectiondata?.data}
                            datestart={dateStart}
                            dateend={dateEnd}
                          />
                        )}
                      </div>
                      <div className="charts_right_child">
                        <CylinderChart
                          cylinderData={sectiondata ? sectiondata?.data : []}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          </div>
        </main>
      )}
      <ReactProSidebar />
    </div>
  );
}

export default DashBoard;
